module.exports = __webpack_public_path__ + "c7a57842af772d9ca81e1ada4a769373.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-ballet.png
// module id = 2536
// module chunks = 0